export default __webpack_public_path__ + "static/media/remove-icon-borderless.fc157393.svg";